export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  // Communication injector script for CMS in-page editing
  const communicationInjector = document.createElement('script');
  communicationInjector.src = `${config.public.cmsUrl as string}/EPiServer/CMS/11.36.7/ClientResources/epi-cms/communicationInjector.js`;
  communicationInjector.async = false;
  communicationInjector.defer = true;
  communicationInjector.type = 'text/javascript';

  // Delivery property renderer script for rendering CMS properties
  const deliveryPropertyRenderer = document.createElement('script');
  deliveryPropertyRenderer.src = `${config.public.cmsUrl as string}/EPiServer/CMS/11.36.7/ClientResources/epi-cms/deliveryPropertyRenderer.js`;
  deliveryPropertyRenderer.async = false;
  deliveryPropertyRenderer.defer = true;
  deliveryPropertyRenderer.type = 'text/javascript';

  // Set document.domain
  const domainScript = document.createElement('script');
  domainScript.type = 'text/javascript';
  domainScript.text = `document.domain = "${config.public.domain as string}";`;

  document.head.appendChild(domainScript);
  document.body.appendChild(communicationInjector);
  document.body.appendChild(deliveryPropertyRenderer);
});
